import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import axios from "../axios/axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { Link, useNavigate, useParams } from "react-router-dom";
import FormFormation from "../components/form-formation";
import ProtectedRoute from "../components/ProtectedRoute";

export default function ModifierFormation() {
  const navigate = useNavigate();
  const { idFormation } = useParams();

  const token = Cookies.get("auth_token");
  const [allFormations, setAllFormations] = useState([]);
  const [searchInputEtablissement, setSearchInputEtablissement] = useState("");
  const [filteredResultsEtablissement, setFilteredResultsEtablissement] =
    useState([]);
  const [chargement, setChargement] = useState(false);

  useEffect(() => {
    getFormation();
    getDomainesEtEtablissementsEtEntreprises();
  }, []);

  const getDomainesEtEtablissementsEtEntreprises = () => {
    axios
      .get("getDomainesEtEtablissementsEtEntreprises/", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setAllFormations(response.data.allFormation);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [formations, setFormations] = useState([
    {
      moisDebut: "",
      anneeDebut: "",
      moisFin: "",
      anneeFin: "",
      encoureFormation: "",
      titreFormation: "",
      specialite: "",
      etablissmenet: "",
      ville: "",
      descriptionFormation: "",
    },
  ]);

  const handleChangeFormation = (index, attributeName, value) => {
    // Mettez à jour la liste des formations en modifiant l'attribut spécifique de la formation à l'index donné
    const updatedFormations = [...formations];
    updatedFormations[index][attributeName] = value;
    setFormations(updatedFormations);
  };

  const handleCheckboxChangeFormation = (index) => {
    const updatedFormations = [...formations];
    updatedFormations[index].encoureFormation =
      !updatedFormations[index].encoureFormation;
    updatedFormations[index].moisFin = "";
    updatedFormations[index].anneeFin = "";

    setFormations(updatedFormations);
  };

  const onChangeEtablissement = (e, index) => {
    const updatedFormations = [...formations];
    updatedFormations[index].etablissmenet = e.target.value;
    setFormations(updatedFormations);
    setSearchInputEtablissement(e.target.value);
    if (searchInputEtablissement !== "") {
      const filteredDataEtablissement = allFormations.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchInputEtablissement.toLowerCase());
      });
      setFilteredResultsEtablissement(filteredDataEtablissement);
    } else {
      setFilteredResultsEtablissement([]);
    }
  };

  const selectItemsEtablissement = (e, index) => {
    const updatedFormations = [...formations];
    console.log(updatedFormations[index]);
    updatedFormations[index].etablissmenet = e.target.value;
    setFormations(updatedFormations);
    setFilteredResultsEtablissement([]);
  };

  const getFormation = () => {
    setChargement(true);
    var moisFin = 0;
    var anneeFin = 0;
    var encoureFormation = null;

    axios
      .get(`/editeFormation/${idFormation}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (
          response.data.msg == "msgNoAuthNoAdmin" ||
          response.data.formation == null
        ) {
          navigate(`${process.env.PUBLIC_URL}/profile`);
        } else {
          const formations = [response.data.formation];
          const updatedFormations = formations.map((formation) => {
            const moisDebut = formation.date_debut.substring(5, 7);
            const anneeDebut = formation.date_debut.substring(0, 4);
            const titreFormation = formation.titre_formation;
            const etablissmenet = formation.etablissement;
            const specialite = formation.specialite;
            const ville = formation.ville;
            const descriptionFormation = formation.description;
            if (formation.date_fin != null && formation.encoure == 0) {
              moisFin = formation.date_fin.substring(5, 7);
              anneeFin = formation.date_fin.substring(0, 4);
            } else {
              encoureFormation = formation.encoure;
              moisFin = "";
              anneeFin = "";
            }

            return {
              ...formation,
              titreFormation,
              specialite,
              etablissmenet,
              ville,
              moisDebut,
              anneeDebut,
              moisFin,
              anneeFin,
              encoureFormation,
            };
          });
          setFormations(updatedFormations);
          setChargement(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const modifierFormation = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Traitement en cours, veuillez patienter ...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const form = new FormData();
    form.append("formations", JSON.stringify(formations));

    axios
      .post("/modifierFormation", form, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        Swal.fire({
          icon: "success",
          text: "Votre formation a été modifier avec succès!",
          confirmButtonText: "Ok",
        }).then(function () {
          if (response.data.user.role == 1) {
            navigate(`${process.env.PUBLIC_URL}/rim`);
          } else {
            navigate(`${process.env.PUBLIC_URL}/consulter-voter-cv`);
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return chargement == true ? (
    <div className="container card text-center mt-5">
      <h4>Chargement .... </h4>
    </div>
  ) : (
    <ProtectedRoute>
      <div
        className="container card"
        style={{ marginTop: "15px", paddingTop: 5 }}
      >
        <br />
        <p style={{ fontWeight: "bold", fontSize: 20 }}>
          <FontAwesomeIcon
            icon={faGraduationCap}
            className="arrow-in-profile"
          />
          Modifier Formation
          <Link
            to={`${process.env.PUBLIC_URL}/consulter-voter-cv`}
            className="btn btn-primary"
            style={{ borderRadius: 0, float: "inline-end" }}
          >
            Précédent
          </Link>
        </p>
        <div style={{ borderTop: "3px solid #eee" }}>
          <br />
        </div>
        <Form style={{ background: "#f1f4fa", padding: "10px", margin: 1 }}>
          <FormFormation
            formations={formations}
            onToggleEncoureFormation={handleCheckboxChangeFormation}
            onChangeFormation={handleChangeFormation}
            onChangeEtablissement={onChangeEtablissement}
            searchInputEtablissement={searchInputEtablissement}
            filteredResultsEtablissement={filteredResultsEtablissement}
            selectItemsEtablissement={selectItemsEtablissement}
          />
          <button
            type="submit"
            className="btn"
            onClick={modifierFormation}
            style={{
              borderRadius: "5px",
              padding: "7px",
              float: "right",
              backgroundColor: "#00ab9f",
              marginTop: 5,
            }}
          >
            Modifier
          </button>
        </Form>
      </div>
    </ProtectedRoute>
  );
}
